import { getTelLinkFromPhone } from "./utils/getTelLinkFromPhone";
import { getWhatsappLinkFromPhone } from "./utils/getWhatsappLinkFromPhone";
//import { formatToURL } from "./utils/formatToURL";

// export function getMenu(component) {
export function getMenu() {
  return [
    {
      text: "Início",
      to: "/",
    },
    {
      text: "Quem Somos",
      to: "/quem-somos",
    },
    {
      text: "Produtos",
      href: "https://vitrine.plantiomaquinas.com.br/",
      // submenu: component.productsCategories.map(({ title }) => ({
      //   text: title,
      //   to: "/produtos/" + formatToURL(title),
      // })),
    },
    {
      text: "Fale Conosco",
      to: "/fale-conosco",
    },
    {
      text: "Trabalhe Conosco",
      to: "/trabalhe-conosco",
    },
  ];
}

export function getSocial(component) {
  const social = [];

  if (component.medias.facebook)
    social.push({
      title: "Facebook",
      link: component.medias.facebook,
      icon: "fab fa-facebook-f",
      size: 20,
    });
  if (component.medias.instagram)
    social.push({
      title: "Instagram",
      link: component.medias.instagram,
      icon: "fab fa-instagram",
      size: 18,
    });
  if (component.medias.youtube)
    social.push({
      title: "Youtube",
      link: component.medias.youtube,
      icon: "fab fa-youtube",
      size: 20,
    });
  if (component.medias.twitter)
    social.push({
      title: "Twitter",
      link: component.medias.twitter,
      icon: "fab fa-twitter",
      size: 20,
    });
  if (component.medias.linkedin)
    social.push({
      title: "Linkedin",
      link: component.medias.linkedin,
      icon: "fab fa-linkedin",
      size: 20,
    });

  return social;
}

export function getContact(component) {
  const contact = [];

  if (component.contacts.phones) {
    let phonesSplit = component.contacts.phones.split(";");

    if (Array.isArray(phonesSplit)) {
      let phones = [];
      phonesSplit.forEach(function (val) {
        phones.push({
          title: val.replace("(", "<small>").replace(")", "</small>"),
          link: getTelLinkFromPhone(val),
          target: "_self",
          icon: "fa-phone-alt",
          size: 16,
        });
      });

      contact.push(phones);
    } else {
      contact.push({
        title: component.contacts.phones
          .replace("(", "<small>")
          .replace(")", "</small>"),
        link: getTelLinkFromPhone(component.contacts.phones),
        target: "_self",
        icon: "fa-phone-alt",
        size: 16,
      });
    }
  }

  if (component.contacts.whatsapp) {
    let whatsappSplit = component.contacts.whatsapp.split(";");

    if (Array.isArray(whatsappSplit)) {
      let whatsapp = [];
      whatsappSplit.forEach(function (val) {
        whatsapp.push({
          title: val.replace("(", "<small>").replace(")", "</small>"),
          link: getWhatsappLinkFromPhone(val),
          target: "_blank",
          icon: "fa-whatsapp",
          size: 20,
        });
      });

      contact.push(whatsapp);
    } else {
      contact.push({
        title: component.contacts.whatsapp
          .replace("(", "<small>")
          .replace(")", "</small>"),
        link: getWhatsappLinkFromPhone(component.contacts.whatsapp),
        target: "_blank",
        icon: "fa-whatsapp",
        size: 20,
      });
    }
  }

  if (component.contacts.email) {
    let emailSplit = component.contacts.email.split(";");

    if (Array.isArray(emailSplit)) {
      let email = [];
      emailSplit.forEach(function (val) {
        email.push({
          title: val,
          link: "mailto:" + val,
          target: "_self",
          icon: "far fa-envelope",
          size: 18,
        });
      });

      contact.push(email);
    } else {
      contact.push({
        title: component.contacts.email,
        link: "mailto:" + component.contacts.email,
        target: "_self",
        icon: "far fa-envelope",
        size: 18,
      });
    }
  }

  if (component.contacts.address)
    contact.push({
      title: component.contacts.address,
      link: component.contacts.google_maps,
      target: "_blank",
      icon: "fa-map-marker-alt",
      size: 18,
    });

  return contact;
}
